// TODO(jacob): Enable/remove this flag once we can delete flows from
// the plugin.
export const FLOW_MANAGEMENT_ENABLED = true;
